import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

/**
 * 🚀 TopProgressBar (controlada globalmente por Redux)
 *
 * - Lee `progress`, `visible` y `position` desde el store.
 * - No maneja lógica interna (fade ni auto-ocultar).
 * - Su único trabajo es representar visualmente el progreso global.
 */
const TopProgressBar: React.FC = () => {
  const { progress, visible, position } = useSelector(
    (state: RootState) => state.topProgress
  );

  if (!visible) return null;

  return (
    <div
      className={`fixed left-0 ${
        position === "top" ? "top-0" : "bottom-0"
      } z-[99999] h-[3px] w-full bg-transparent`}
    >
      <div
        className="h-full bg-primary transition-[width] duration-200 ease-linear shadow-[0_0_6px_rgba(59,130,246,0.8)]"
        style={{
          width: `${progress}%`,
        }}
      />
    </div>
  );
};

export default TopProgressBar;
